import { render, staticRenderFns } from "./website-statistics.vue?vue&type=template&id=240b0c2c&scoped=true&"
import script from "./website-statistics.vue?vue&type=script&lang=js&"
export * from "./website-statistics.vue?vue&type=script&lang=js&"
import style0 from "./website-statistics.vue?vue&type=style&index=0&id=240b0c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240b0c2c",
  null
  
)

export default component.exports